import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {OverlayComponentBox} from "./boxes/overlay.component.box";
import {CyClass} from '../../../common/cy-classes';

@observer
export class OverlayComponent extends OrbitComponent {

  private _onClickHandler = () => {
    this.services.overlay.closeOverlay();
  };

  render() {
    return <OverlayComponentBox
      className={CyClass('cy-overlay')}
      onClick={this._onClickHandler}
      show={this.services.overlay.isOpen}
      zIndex={this.services.overlay.zIndex}
    />;
  }
}
